const ALL_GLOBAL_VARIABLES = {
    useRecordAPI: true,
    host: "https://api.gridgoal.com"
    // host: "http://localhost:3001"

  };
  
  export default ALL_GLOBAL_VARIABLES;
  